/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestUpdateAmazonInfoRequest
 */
export interface RequestUpdateAmazonInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof RequestUpdateAmazonInfoRequest
     */
    mwsToken: string;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdateAmazonInfoRequest
     */
    sellerId: string;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateAmazonInfoRequest
     */
    tenantId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateAmazonInfoRequest
     */
    userId: number;
}

/**
 * Check if a given object implements the RequestUpdateAmazonInfoRequest interface.
 */
export function instanceOfRequestUpdateAmazonInfoRequest(value: object): value is RequestUpdateAmazonInfoRequest {
    if (!('mwsToken' in value) || value['mwsToken'] === undefined) return false;
    if (!('sellerId' in value) || value['sellerId'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function RequestUpdateAmazonInfoRequestFromJSON(json: any): RequestUpdateAmazonInfoRequest {
    return RequestUpdateAmazonInfoRequestFromJSONTyped(json, false);
}

export function RequestUpdateAmazonInfoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestUpdateAmazonInfoRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'mwsToken': json['mws_token'],
        'sellerId': json['seller_id'],
        'tenantId': json['tenant_id'],
        'userId': json['user_id'],
    };
}

export function RequestUpdateAmazonInfoRequestToJSON(json: any): RequestUpdateAmazonInfoRequest {
    return RequestUpdateAmazonInfoRequestToJSONTyped(json, false);
}

export function RequestUpdateAmazonInfoRequestToJSONTyped(value?: RequestUpdateAmazonInfoRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mws_token': value['mwsToken'],
        'seller_id': value['sellerId'],
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
    };
}

